(function () {
    'use strict';

    angular.module('app.productBrand', [
        // Angular modules 
        'ngRoute'

        // Custom modules 

        // 3rd Party Modules
        
    ]);
})();